import React from 'react';
import { connect } from 'react-redux';
import {
    getDeleteDormantClientMessage,
    getDeleteDormantClientStatus,
    getIsLoadingDeleteDormantClient,
    getMobile,
    getMobileUserInfo,
    isModalOpen
} from "../../selectors";
import {
    closeDormantClientPopupAction, deleteLogiParmaDormantClientAction,
    setModalOpenAction,
    setTelephoneValidationData,
} from "../../reducers";
import {SERVER_CDN_PATH} from "../../constants";

const stateToProps = state => ({
    isModalOpen: isModalOpen(state),
    deleteDormantClientStatus: getDeleteDormantClientStatus(state),
    isLoadingDeleteDormantClient: getIsLoadingDeleteDormantClient(state),
    mobile: getMobile(state),
    deleteDormantClientMessage: getDeleteDormantClientMessage(state),
    mobileUserInfo: getMobileUserInfo(state),
});

const actionsToProps = dispatch => ({
    deleteDormantClient: payload => dispatch(deleteLogiParmaDormantClientAction(payload)),
    setModalOpen: payload => dispatch(setModalOpenAction(payload)),
    setTelephoneValidationData: payload => dispatch(setTelephoneValidationData(payload)),
    closeDormantClientPopup: payload => dispatch(closeDormantClientPopupAction(payload)),
});

const ModalDeleteDormantUser = props => {
    if (props.isModalOpen) {
        let modalBody = '';

        if (props.deleteDormantClientStatus === 1) {
            modalBody = (
                <div className="modal-body">
                    <div className="modal-note">
                        <div className="modal-img">
                            <div className="modal-icon correct-icon"></div>
                        </div>
                        <div className="modal-message">User successfully deleted</div>
                    </div>
                    <div className="modal-txt">
                        Now you can proceed with registration using the selected mobile number
                    </div>
                    <div className="modal-button" onClick={() => updateModal()}>Continue</div>
                </div>
            );
        } else if (props.deleteDormantClientStatus === 0) {
            const showButton = !props.isLoadingDeleteDormantClient ?

                <div className="modal-box">
                    <div className="modal-button" onClick={() => deleteDormantClient()}>Continue</div>
                    <div className="modal-button" onClick={() => updateModal()}>Cancel</div>
                </div>
                :
                <span style={{marginTop: '20px'}}><img src={`/${SERVER_CDN_PATH}/img/loading.gif`} alt="spinner"/></span>
            ;

            modalBody = (
                <div className="modal-body">
                    <div className="modal-note">
                        <div className="modal-img">
                            <div className="modal-icon error-icon"></div>
                        </div>
                        <div className="modal-message">
                            Mobile number already exists
                        </div>
                    </div>
                    <div className="modal-txt">
                        The mobile number is already assigned to an existing account.
                    </div>

                    <div className="modal-txt">
                        By clicking on the "Continue" button you agree to proceed with
                        registration: the old user associated with this mobile number will be permanently deleted from
                        the system (recovery will not be possible).
                    </div>

                    {showButton}
                </div>
            );
        } else {
            // deleteDormantClientStatus = -1
            modalBody = (
                <div className="modal-body">
                    <div className="modal-note">
                        <div className="modal-img">
                            <div className="modal-icon error-icon"></div>
                        </div>
                        <div className="modal-message">
                            Operation Error
                        </div>
                    </div>
                    <div className="modal-txt">
                        Unable to proceed with registration
                    </div>

                    <div className="modal-txt pt5">
                        Please contact customer service for further information
                    </div>

                    <div className="modal-button" onClick={() => updateModal()}>Close</div>
                </div>
            );
        }

        const updateModal = open => {
            props.closeDormantClientPopup();
        }

        const deleteDormantClient = () => {
            if (props.mobile !== '' && props.mobileUserInfo != null && props.mobileUserInfo.UserID != null) {
                props.deleteDormantClient({
                    mobile: props.mobile,
                    clientId: props.mobileUserInfo.UserID
                });
            } else {
                console.log('Error deleting client', props);
            }
        }

        return (
            <div className="modals verification-link-modal">
                <div className="verification-link-modal">
                    <div className="modal-dialog">
                        <div className="modal-content">
                            <div className="modal-head">
                                <a className="modal-close" href="#" onClick={() => updateModal()}></a>
                            </div>
                            {modalBody}
                        </div>
                    </div>
                </div>
                <div className="modal-mask"></div>
            </div>
        );
    }
}

export default connect(
    stateToProps,
    actionsToProps
)(ModalDeleteDormantUser);
